import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetCurrencyCodeListQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(): Promise<any> {
    let args = {}
    let res = await this.dispatcher.dispatch('currency_code_list.data', args)
    if (res) {
      this.frontend.available_currencies = res
    }
  }
}